function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "svg_1",
  stroke: "#172342",
  fill: "#ECF2F8",
  r: 9.5,
  cy: 10,
  cx: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "svg_2",
  fill: "#172342",
  d: "m5.50507,5.42865c0.27337,-0.27337 0.71659,-0.27337 0.98995,0l3.50498,3.50507l3.5051,-3.50507c0.2733,-0.27337 0.7166,-0.27337 0.9899,0c0.2734,0.27336 0.2734,0.71658 0,0.98994l-4,4.00003c-0.2733,0.2733 -0.71656,0.2733 -0.98993,0l-4,-4.00003c-0.27336,-0.27336 -0.27336,-0.71658 0,-0.98994z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-179.6091766357422 10.028874397277832,12.45173454284668) ",
  id: "svg_3",
  fill: "#172342",
  d: "m5.53389,9.95678c0.27337,-0.27337 0.71659,-0.27337 0.98995,0l3.50498,3.50507l3.5051,-3.50507c0.2733,-0.27337 0.7166,-0.27337 0.9899,0c0.2734,0.27336 0.2734,0.71658 0,0.98994l-4,4.00003c-0.2733,0.2733 -0.71656,0.2733 -0.98993,0l-4,-4.00003c-0.27336,-0.27336 -0.27336,-0.71658 0,-0.98994z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

function SvgCircleCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCloseIcon);
export default __webpack_public_path__ + "static/media/CircleCloseIcon.91eb2e8a.svg";
export { ForwardRef as ReactComponent };